import type { FC } from "react"

import { BirthdateField, RadioField } from "commons"
import { genders } from "utils"

const sexOptions = [...genders].reverse()

const OnboardingStepDemographics: FC = () => (
  <div className="flex flex-col gap-4 md:gap-6">
    <div>
      <h2 className="text-2xl leading-6 font-semibold text-gray-900">Date of birth &amp; biological sex</h2>
      <p className="text-base leading-5 text-gray-500 mt-2">This helps your practitioner personalize your care.</p>
    </div>
    <div className="flex flex-col space-y-1">
      <BirthdateField field="birthdate" label="Date of birth" variant="calendar" inputClassName="!h-[2.625rem]" />
      <RadioField field="gender" label="Biological sex" options={sexOptions} />
    </div>
  </div>
)

export { OnboardingStepDemographics }
